import React from "react";
import { Box } from "@mui/system";
import { styles } from "./styles";
import NoSuggestionsAutoComplete from "../Autocomplete/NoSuggestionsAutoComplete";
import { useDispatch, useSelector } from "react-redux";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import { initialFilterPayload } from "../../redux/store/storeConstants";
import {
  allFilters,
  filterHeaderCompanyLinkedInDesc,
} from "../../redux/actions/filterActions";
import Checkbox from "../Buttons/Checkbox/Checkbox";
import { STRINGS } from "./strings";

const CompanyLinkedinDescriptionFilter = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const selectedJobFilter = useSelector(
    (state) => state?.filterHeaderCompanyLinkedInDesc?.payload
  );

  const allFiltersSelector = useSelector((state) => state?.allFilters?.payload);

  const handleExistFields = (
    existing_type,
    filter,
    filterKey,
    notFilterKey
  ) => {
    // existing_type = isKnown/ isUnknown
    // filter = company_linkedin_description

    let payload = {
      ...initialFilterPayload?.payload,
      [existing_type]: !selectedJobFilter[existing_type],
    };

    payload = JSON.parse(JSON.stringify(payload));
    dispatch(filterHeaderCompanyLinkedInDesc(payload));
    if (payload?.[existing_type]) {
      const queryPayload = {
        [filterKey]: [...allFiltersSelector?.[filterKey], filter],
        [notFilterKey]: [...allFiltersSelector?.[notFilterKey]].filter(
          (e) => e !== filter
        ),
        [filter]: [],
        [filter + "_not"]: [],
        [filter + "_all"]: [],
      };

      dispatch(allFilters(queryPayload));
      navigate({
        pathname: location.pathname,
        search: createSearchParams({
          ...allFiltersSelector,
          ...queryPayload,
        }).toString(),
      });
    } else {
      const queryPayload = {
        [filterKey]: [...allFiltersSelector?.[filterKey]].filter(
          (e) => e !== filter
        ),
      };
      dispatch(allFilters(queryPayload));
      navigate({
        pathname: location.pathname,
        search: createSearchParams({
          ...allFiltersSelector,
          ...queryPayload,
        }).toString(),
      });
    }
  };

  const handleCompanyLinkedInDescChange = (item, filter) => {
    let payload = {
      ...selectedJobFilter,
      [item]: !selectedJobFilter[item],
      isKnown: false,
      isUnknown: false,
    };

    // clear data if column is empty.
    const unCheckPayload = {};
    if (!payload?.anyOf) {
      unCheckPayload[filter] = [];
    }
    if (!payload?.notAnyOf) {
      unCheckPayload[filter + "_not"] = [];
    }
    if (!payload?.allOf) {
      unCheckPayload[filter + "_all"] = [];
    }
    // clear data if column is empty.

    dispatch(
      allFilters({
        ...unCheckPayload,
        exist_fields: [...allFiltersSelector.exist_fields].filter(
          (e) => e !== filter
        ),
        not_exist_fields: [...allFiltersSelector.not_exist_fields].filter(
          (e) => e !== filter
        ),
      })
    );
    navigate({
      pathname: location.pathname,
      search: createSearchParams({
        ...allFiltersSelector,
        ...unCheckPayload,
        exist_fields: [...allFiltersSelector.exist_fields].filter(
          (e) => e !== filter
        ),
        not_exist_fields: [...allFiltersSelector.not_exist_fields].filter(
          (e) => e !== filter
        ),
      }).toString(),
    });
    dispatch(filterHeaderCompanyLinkedInDesc(payload));
  };

  return (
    <Box sx={styles.container}>
      <Box sx={styles.containAllFilter}>
        <Box sx={styles.jobTitleHead}>
          <Checkbox
            checked={selectedJobFilter?.anyOf}
            onClick={() =>
              handleCompanyLinkedInDescChange(
                "anyOf",
                "company_linkedin_description"
              )
            }
            label={STRINGS.IS_ANY_OF}
          />
        </Box>

        {selectedJobFilter?.anyOf ? (
          <Box>
            {" "}
            <NoSuggestionsAutoComplete
              filter="company_linkedin_description"
              type=""
            />{" "}
          </Box>
        ) : null}

        <Box sx={styles.jobTitleHead}>
          <Checkbox
            checked={selectedJobFilter?.notAnyOf}
            onClick={() =>
              handleCompanyLinkedInDescChange(
                "notAnyOf",
                "company_linkedin_description"
              )
            }
            label={STRINGS.IS_NOT_ANY_OF}
          />
        </Box>

        {selectedJobFilter?.notAnyOf ? (
          <Box>
            <NoSuggestionsAutoComplete
              filter="company_linkedin_description"
              type="_not"
            />
          </Box>
        ) : null}

        <Box sx={styles.jobTitleHead}>
          <Checkbox
            checked={selectedJobFilter?.isKnown}
            onClick={() =>
              handleExistFields(
                "isKnown",
                "company_linkedin_description",
                "exist_fields",
                "not_exist_fields"
              )
            }
            label={STRINGS.IS_KNOWN}
          />
        </Box>
        <Box sx={styles.jobTitleHead}>
          <Checkbox
            checked={selectedJobFilter?.isUnknown}
            onClick={() =>
              handleExistFields(
                "isUnknown",
                "company_linkedin_description",
                "not_exist_fields",
                "exist_fields"
              )
            }
            label={STRINGS.IS_UNKNOWN}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default CompanyLinkedinDescriptionFilter;
